<template>
  <v-navigation-drawer
    v-model="_show"
    app
    clipped
    mini-variant-width="70"
    :mini-variant="expand"
    :expand-on-hover="expand"
    mobile-breakpoint="960"
    id="main-sidebar"
  >
    <v-list>
      <LinkItem
        v-for="link in user.links"
        :key="link.id"
        :link="link"
        :active-url="activeUrl"
      />
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "NavigationDrawer",
  props: {
    activeUrl: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters("Navigation", ["drawer", "expand"]),
    ...mapGetters("Auth", {
      user: "loggedInUser"
    }),
    _show: {
      get() {
        return this.drawer;
      },
      set(drawer) {
        if (drawer != this.drawer) {
          this.SET_DRAWER(!this.drawer);
        }
      }
    }
  },
  methods: {
    ...mapMutations("Navigation", ["SET_DRAWER"])
  }
};
</script>

<style></style>
